module.exports = __webpack_public_path__ + "img/Video-Header-Placeholder.jpg";